import { Button, Checkbox, FormControlLabel, Menu } from '@mui/material';
import { useState } from 'react';

interface NonVacantLotsDropdownProps {
  includeNonVacantLots: boolean;
  onIncludeNonVacantLotsChange: (val: boolean) => void;
}

// TODO: Make this a generic component that can be reused
export const NonVacantLotsDropdown = ({
  includeNonVacantLots,
  onIncludeNonVacantLotsChange,
}: NonVacantLotsDropdownProps) => {
  const [open, setOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <div className={`non-vacant-dropdown-container`}>
      <Button
        data-open-price-dropdown
        data-open-price-dropdown-has-value={includeNonVacantLots ? true : false}
        id="open-vacant-lots-dropdown-button"
        aria-controls={open ? 'vacant-lots-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={() => setOpen(true)}
        variant="filled"
        ref={setAnchorEl}
      >
        {includeNonVacantLots ? 'Including Non-Vacant Lots' : 'Vacant Lots'}
      </Button>
      <Menu
        sx={{ width: '100%', '& .MuiPaper-root': { padding: '12px' } }}
        id="vacant-lots-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setOpen(false)}
        slotProps={{
          list: {
            'aria-labelledby': 'open-vacant-lots-dropdown-button',
          },
        }}
      >
        <div>
          <FormControlLabel
            data-utilities-dropdown-option
            labelPlacement="end"
            control={
              <Checkbox
                checked={includeNonVacantLots}
                onChange={(e) => {
                  return onIncludeNonVacantLotsChange(e.target.checked);
                }}
              />
            }
            label="Include Non-Vacant Lots"
          />
        </div>
      </Menu>
    </div>
  );
};
